import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { ChartModule } from 'primeng/chart';
import { SkeletonModule } from 'primeng/skeleton';
import { TranslateModule } from '@ngx-translate/core';
import { CardComponent } from '@/shared/ui-components/card/card.component';
import { RmClientSectorPreferenceDto } from '../../data-access/relationship-manager-dashboard.model';

@Component({
    selector: 'app-rm-sector-preferences',
    standalone: true,
    imports: [CommonModule, ChartModule, SkeletonModule, TranslateModule, CardComponent],
    templateUrl: './rm-sector-preferences.component.html',
})
export class RmSectorPreferencesComponent {
    public readonly items = input<RmClientSectorPreferenceDto[]>([]);
    public readonly loading = input(false);

    public readonly sectorChartData = computed(() => {
        const items = this.items();
        return {
            labels: items.map((item) => this.wrapChartLabel(item.sector)),
            datasets: [
                {
                    label: 'Clients',
                    data: items.map((item) => item.count),
                    backgroundColor: ['#176D87', '#2C8E95', '#B7995D', '#6B8E5F', '#7B6F9E', '#D08A5B'],
                    borderRadius: 4,
                    maxBarThickness: 48,
                },
            ],
        };
    });

    public readonly sectorChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: {
                bottom: 8,
            },
        },
        plugins: {
            legend: {
                display: false,
            },
        },
        scales: {
            x: {
                grid: {
                    display: false,
                },
                ticks: {
                    color: '#52606D',
                    maxRotation: 0,
                    minRotation: 0,
                    autoSkip: false,
                    padding: 8,
                    font: {
                        size: 12,
                        weight: '500',
                    },
                },
            },
            y: {
                beginAtZero: true,
                ticks: {
                    precision: 0,
                    color: '#52606D',
                    font: {
                        size: 12,
                        weight: '500',
                    },
                },
                grid: {
                    color: '#E5E7EB',
                },
            },
        },
    };

    public hasItems(): boolean {
        return this.items().length > 0;
    }

    private wrapChartLabel(label: string, maxCharsPerLine = 16): string | string[] {
        if (label.length <= maxCharsPerLine) return label;
        const words = label.split(' ');
        let line1 = '';
        let line2 = '';
        for (const word of words) {
            const nextLine1 = line1 ? `${line1} ${word}` : word;
            if (!line2 && nextLine1.length <= maxCharsPerLine) {
                line1 = nextLine1;
                continue;
            }
            line2 = line2 ? `${line2} ${word}` : word;
        }
        return line2 ? [line1, line2] : line1;
    }
}
